// extracted by mini-css-extract-plugin
export default {"add":"OrderDetailsCopy_add__t+HzP","remove":"OrderDetailsCopy_remove__e1VyR","headerContainer":"OrderDetailsCopy_headerContainer__tUWuW","header":"OrderDetailsCopy_header__CGiDN"};